<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm
            ref="sendLeadsToDeliveryCampaignWithTrollingDelivery"
            @submit="
                submitForm(
                    $event,
                    'sendLeadsToDeliveryCampaignWithTrollingDelivery'
                )
            "
        >
            <SelectAsync
                :label="'TimeZone'"
                :horizontal="true"
                :options="['UTC', 'Europe/Madrid', 'Europe/Rome']"
                :value.sync="
                    forms.sendLeadsToDeliveryCampaignWithTrollingDelivery
                        .timeZone
                "
                :placeholder="$t('Select a timezone')"
            />

            <CCRange
                :value.sync="
                    forms.sendLeadsToDeliveryCampaignWithTrollingDelivery
                        .scheduleBias
                "
                :label="$t('Frequency')"
                :min="0.1"
                :max="1"
                :step="0.1"
                type="range"
                :horizontal="inputHorizontal"
                size="sm"
            />

            <CInput
                :isValid="
                    checkIfFormValid({
                        formName:
                            'sendLeadsToDeliveryCampaignWithTrollingDelivery',
                        fieldName: 'maxConcurrency',
                    })
                "
                :value.sync="
                    $v.forms.sendLeadsToDeliveryCampaignWithTrollingDelivery
                        .maxConcurrency.$model
                "
                type="number"
                :label="$t('Max concurrency')"
                :placeholder="$t('Enter a max concurrency possible')"
                :invalidFeedback="$t('Requiered a number')"
                :horizontal="inputHorizontal"
                size="sm"
            />

            <CInput
                :isValid="
                    checkIfFormValid({
                        formName:
                            'sendLeadsToDeliveryCampaignWithTrollingDelivery',
                        fieldName: 'minConcurrency',
                    })
                "
                :value.sync="
                    $v.forms.sendLeadsToDeliveryCampaignWithTrollingDelivery
                        .minConcurrency.$model
                "
                type="number"
                :label="$t('Min concurrency')"
                :placeholder="$t('Enter a number min concurrency possible')"
                :invalidFeedback="$t('Requiered a number')"
                :horizontal="inputHorizontal"
                size="sm"
            />

            <br />

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="
                    forms.sendLeadsToDeliveryCampaignWithTrollingDelivery
                        ._loading
                "
            >
                <span>{{ $t("send") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading
                color="primary"
                @click="
                    executeSubmitForm(
                        'sendLeadsToDeliveryCampaignWithTrollingDelivery'
                    )
                "
                :loading="
                    forms.sendLeadsToDeliveryCampaignWithTrollingDelivery
                        ._loading
                "
            >
                {{ $t("send") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
/** Components */
import SelectAsync from "~/components/elements/SelectAsync.vue";
import CCRange from "~/components/CCRange.vue";
import ButtonLoading from "~/components/ButtonLoading.vue";

/** Mixins */
import formMixin from "~/mixins/form";
import modalComponentMixin from "~/mixins/modalComponent";

/** Others */
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
    name: "CCDeliveryPendingsWithThrollingDeliveryModal",
    mixins: [formMixin, validationMixin, modalComponentMixin],
    components: {
        SelectAsync,
        ButtonLoading,
        CCRange,
    },
    data() {
        return {
            forms: {
                sendLeadsToDeliveryCampaignWithTrollingDelivery: {
                    deliveryCampaignId: null,
                    timeZone: null,
                    scheduleBias: 1,
                    maxConcurrency: 5,
                    minConcurrency: 1,
                    _loading: false,
                },
            },
            inputHorizontal: {
                label: "col-sm-3",
                input: "col-sm-9",
            },
        };
    },
    props: {
        leads: {
            type: Array,
            required: true,
        },
        deliveryCampaignId: {
            required: true,
        },
    },
    validations: {
        forms: {
            sendLeadsToDeliveryCampaignWithTrollingDelivery: {
                timeZone: {
                    required,
                },
                maxConcurrency: {
                    required,
                },
                minConcurrency: {
                    required,
                },
                scheduleBias: {
                    required,
                },
            },
        },
    },

    watch: {
        show() {
            this.showComponent = this.show;
        },

        showComponent() {
            if (!this.showComponent) {
                this.resetForms();
                this.$v.forms.sendLeadsToDeliveryCampaignWithTrollingDelivery.$reset();
            }
        },
    },

    methods: {
        async submitForm(e, formName) {
            e.preventDefault();
            this.$v.forms.sendLeadsToDeliveryCampaignWithTrollingDelivery.$touch();
            try {
                if (
                    this.$v.forms
                        .sendLeadsToDeliveryCampaignWithTrollingDelivery
                        .$invalid
                ) {
                    throw { code: 422, message: this.$t("Invalid data") };
                }

                this.forms.sendLeadsToDeliveryCampaignWithTrollingDelivery._loading = true;

                await this.fetcher({
                    url: `/throttling-service/throttling-delivery-pendings`,
                    method: "POST",
                    baseURL: process.env.VUE_APP_API_SASS,
                    data: {
                        leads: this.leads.map((lead) => {
                            return {
                                id: lead.id,
                                uuidSendingRef: lead.uuidSendingRef,
                            };
                        }),
                        deliveryCampaignId: this.deliveryCampaignId,
                        configuration: {
                            timeZone: this.forms[formName].timeZone,
                            maxConcurrency: this.forms[formName].maxConcurrency
                                ? parseInt(this.forms[formName].maxConcurrency)
                                : null,
                            minConcurrency: this.forms[formName].minConcurrency
                                ? parseInt(this.forms[formName].minConcurrency)
                                : null,
                            scheduleBias: this.forms[formName].scheduleBias
                                ? parseFloat(this.forms[formName].scheduleBias)
                                : 1,
                        },
                    },
                });

                this.showMessageSuccess();
                this.showComponent = false;

                this.$emit("submit", formName);
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.forms.sendLeadsToDeliveryCampaignWithTrollingDelivery._loading = false;
            }
        },
        resetForm(formName) {
            let form = this.getForm(formName);
            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key)) {
                    if (typeof form[key] === "boolean") {
                        form[key] = false;
                    } else {
                        form[key] = null;
                    }
                }
            }
            return form;
        },
    },
};
</script>
